<template>
    <div class="scandetails">
        <table class="table" v-if="scansDetail.length">
            <caption> Consignment Scans</caption>
            <thead>
            <tr>
                <th width="30px"></th>
                <th class="table__header">Scanned</th>
                <th class="table__header" width="80px">Scans</th>
                <th class="table__header">Action</th>
                <th class="table__header">Driver</th>
                <th class="table__header">Additional Info</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(item, index) in scansDetail">
                <tr :key="index * 100" class="scans__row__main">
                    <td><button class="toggle-button" type="button" @click="toggleScanDetails(item)">
                        <span v-if="!showDetailRow(item)">+</span>
                        <span v-else>-</span>
                    </button></td>
                    <td class="table__cell">{{ formatDate(item.Scanned,'YYYY-MM-DD') }}</td>
                    <td class="table__cell">{{ item.scans.length }}</td>
                    <td class="table__cell">{{ item.ScanType }}</td>
                    <td class="table__cell"></td>
                    <td class="table__cell"></td>
                </tr>
                <tr v-if="showDetailRow(item)"
                    v-for="(_scan, scanIndex) in item.scans" :key="(index * 100) + 1 + scanIndex"
                    class="scans__row__detail">
                    <td class="scans__cell__detail"></td>
                    <td class="scans__cell__detail">{{ formatDate(item.Scanned,'YYYY-MM-DD HH:mm:ss') }}</td>
                    <td class="scans__cell__detail"></td>
                    <td class="scans__cell__detail">{{ _scan.Barcode }}</td>
                    <td class="scans__cell__detail">{{ _scan.DeliveredBy }}</td>
                    <td class="scans__cell__detail">{{ _scan.ExtraInfo }}</td>
                </tr>
            </template>
            </tbody>
        </table>
    </div>
</template>


<script>
  import moment from 'moment'

  export default {
    props: {
      scans: Array
    },
    data () {
      return {
        activeScanDetails: []
      }
    },
    computed: {
        scansDetail() {

            //function removeDuplicates(myArr, prop) {
            //    return myArr.filter((obj, pos, arr) => {
            //        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
            //    });
            //}

            //let uniqueScans = removeDuplicates(this.scans, 'Barcode')

            return this.scans.concat()
                .sort((a, b) => (a.Scanned > b.Scanned) ? -1 : 1)
                // group by date
                .reduce((current, scan) => {
                    const groupKey = moment(scan.Scanned).format('YYYYMMDD') + '_' + scan.ScanType
                    let currentScan = current.find(s => s.key === groupKey)
                    if (!current.find(s => s.key === groupKey)) {
                        currentScan = { key: groupKey, scans: [], ...scan }
                        current.push(currentScan)
                    }
                    currentScan.scans.push(scan)
                    return current
                }, [])
        }
    },
    methods: {
      formatDate (datetime, format) {
        return moment(String(datetime)).format(format)
      },

      toggleScanDetails (item) {
        if (~this.activeScanDetails.indexOf(item.key)) {
          this.activeScanDetails.splice(this.activeScanDetails.indexOf(item.key), 1)
        } else {
          this.activeScanDetails.push(item.key)
        }
      },

      showDetailRow(item){
        return ~this.activeScanDetails.indexOf(item.key)
        },     

    }
  }
</script>

<style lang="scss" scoped>
    .scans__row__main {
        font-weight: bold;
    }
    
    .toggle-button {
        width: 20px;
        line-height: 20px;
        padding: 0;
        box-shadow: none;
        background-color: lightgray;
        color: black;
    }

    .scandetails table td {
        padding-bottom: 18px;
    }
</style>